const VehicleTypeModule = {
  namespaced: true,
  state: {
    data: [],
    dialog: false,
    formData: []
  },
  mutations: {
    UPDATE_DIALOG: (state, payload) => {
      state.dialog = payload
    },
    SET_FORMDATA: (state, payload) => {
      state.formData = payload
    },
    FETCH: (state, payload) => {
      state.data = payload
    },
    DELETE: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload)
      state.data.splice(index, 1)
    },
    INSERT: (state, payload) => {
      let index = state.data.findIndex(data => data.idx === payload.idx)
      state.data[index] = payload
    }
  },
  actions: {
    async fetch({ commit, dispatch }) {
      try {
          const response = await axios.get(`/vehicle/type/get`)
          commit('FETCH', response.data)
      } catch (error) {
        const notification = {
          type: 'error',
          message: 'There was a problem: ' + error.message
        }
        dispatch('Notification/add', notification, { root: true })
      }
    },
    async delete({ commit, dispatch }, payload) {
      try {
        const response = await axios.delete(`/vehicle/type/delete/${payload}`)
        if (response.data.message === true) {
          commit('DELETE', payload)
          const notification = {
            type: 'success',
            message: 'Your vehicle type has been deleted!'
          }
          dispatch('Notification/add', notification, { root: true })
        }
      } catch (error) {
        const notification = {
          type: 'error',
          message: 'There was a problem: ' + error.message
        }
        dispatch('Notification/add', notification, { root: true })
      }
    },
    async insert({ commit, dispatch }, payload) {
      try {
        const response = await axios.post(`/vehicle/type/insert`, payload)
        // console.log(response.data);
        if (response.data.message === true) {
          dispatch('fetch')
          commit('INSERT', payload)
          const notification = {
            type: 'success',
            message: 'Your vehicle type has been created!'
          }
          dispatch('Notification/add', notification, { root: true })
          return response.data.idx
        }
      } catch (error) {
        const notification = {
          type: 'error',
          message: 'There was a problem: ' + error.message
        }
        dispatch('Notification/add', notification, { root: true })
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    },
    getById: state => payload => {
      return state.data.filter(item => item.idx.match(payload))
    }
  }
}

export default VehicleTypeModule



// WEBPACK FOOTER //
// ./src/store/modules/logistics/vehicle_type.js